<template>
  <div class="tgb-inputitems relative flex w-full items-center" :class="rootClass">
    <span
      v-if="icon"
      class="tgb-inputitems__icon pointer-events-none absolute left-3 top-1/2 z-[1] -translate-y-1/2"
      :class="`${iconPack} fa-${icon}`"
    ></span>
    <div class="tgb-inputitems__container flex min-h-10 w-full flex-1 flex-wrap items-center gap-2">
      <span
        v-for="(item, index) in items"
        :key="index"
        class="tgb-inputitems__item inline-flex items-center gap-1 rounded px-2 py-1"
        :class="itemClass"
      >
        {{ item }}
        <button
          v-if="closable"
          type="button"
          class="tgb-inputitems__item-close inline-flex items-center justify-center bg-none p-0"
          :class="closeClass"
          @click="removeItem(index)"
        >
          <span class="fas fa-times"></span>
        </button>
      </span>
      <input
        ref="input"
        class="tgb-inputitems__input min-w-[120px] flex-1 border-0 outline-none focus:ring-2 focus:ring-blue-500"
        :class="inputClass"
        type="text"
        :placeholder="placeholder"
        :disabled="disabled"
        v-model="newItem"
        @keydown="onKeydown"
        @blur="onBlur"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Inputitems',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    placeholder: String,
    disabled: Boolean,
    confirmKeys: {
      type: Array,
      default: () => [',', 'Tab', 'Enter', ' '],
    },
    closable: {
      type: Boolean,
      default: true,
    },
    icon: String,
    iconPack: String,
    inputClass: String,
    itemClass: String,
    closeClass: String,
    rootClass: String,
    expanded: Boolean,
  },
  data() {
    return {
      newItem: '',
      items: this.value || [],
    };
  },
  watch: {
    value(newValue) {
      this.items = newValue || [];
    },
    items(newValue) {
      this.$emit('input', newValue);
    },
  },
  methods: {
    onKeydown(event) {
      const key = event.key === ' ' ? ' ' : event.key;

      if (this.confirmKeys.includes(key) || this.confirmKeys.includes('Tab') && event.key === 'Tab') {
        event.preventDefault();
        this.addItem();
      } else if (event.key === 'Backspace' && !this.newItem && this.items.length) {
        this.removeItem(this.items.length - 1);
      }
    },
    addItem() {
      const value = this.newItem.trim();
      if (value) {
        this.items = [...this.items, value];
        this.newItem = '';
        this.$emit('add', value);
        this.$emit('input', this.items);
      }
    },
    removeItem(index) {
      const removed = this.items[index];
      this.items = this.items.filter((_, i) => i !== index);
      this.$emit('remove', removed);
      this.$emit('input', this.items);
    },
    onBlur(event) {
      this.$emit('blur', event);
    },
  },
};
</script>
